import styled from "styled-components";
const CardImpl = styled("article")(({ theme }) => ({
  backgroundColor: "white",
  borderRadius: "inherit",
  boxShadow: `inset 0 0 0 1px ${theme.borderColor}`,
  display: "flex",
  height: "100%",
  minHeight: 56,
  minWidth: 56,
  position: "relative"
}));
export {
  CardImpl
};
